<template>
    <div class="w-100 white">
        <f-title class="mt-2" :title="title">
            <template v-slot:right>
                <div class="v-flex" style="margin-left: -55px; margin-top: -4px;">
                    <c-toolbar-button
                        :icon     = "expand ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'"
                        size     = "21"
                        color    = "primary"
                        :tooltip = "expand ? $t('dms.tree.collapse') : $t('dms.tree.expand')"
                        @click   = "onExpand"
                    />
                    <!--
                    <c-toolbar-button
                        icon     = "mdi-refresh"
                        size     = "21"
                        color    = "primary"
                        :tooltip = "$t('dms.refresh.tooltip')"
                        @click   = "onRefresh"
                    />
                    -->
                </div>
            </template>
        </f-title>
        <v-text-field
            v-model        = "search"
            clear-icon=    " fas fa-times"
            class          = "mb-3"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            hide-details
            clearable
        ></v-text-field>
        <div>
            <v-treeview
                :open-all     = "expand"
                :items        = "folders"
                item-key      = "id"
                item-text     = "name"
                item-children = "entries"
                ref           = "treeview"
                hoverable
                dense
            >
                <template v-slot:label="{ item, open }">
                    <div class="v-flex">
                        <div class="no-frame" style="width: 70%">
                            <div class="v-flex" v-if  = "item.type === 3">
                                <div style = "width: 25px;">
                                    <v-icon
                                        size = "21"
                                        color="primary"
                                    >
                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                    </v-icon>
                                </div>

                                <div
                                    style="padding-top: 2px; font-size: 15px;"
                                    class="primary--text"
                                >
                                    {{ item.name }}
                                </div>
                            </div>

                            <c-dms-filename
                                :item     = "item"
                                @document = "onDocument"
                            >
                                <template v-slot:filename="{ item }">
                                    <v-tooltip bottom  >
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                                v-bind = "attrs"
                                                v-on   = "on"
                                                class  = "v-flex"
                                            >
                                                <div :class="getUnit(item) ? 'unit-doc' : ''">
                                                    <span class="primary--text">{{ item.name }}</span>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if = "getUnit(item)">
                                            Anlage {{ getUnit(item) }} zugeordnet
                                        </div>
                                        <div v-if = "!getUnit(item)">
                                            Allen Anlagen zugeordnet
                                        </div>
                                    </v-tooltip>
                                </template>
                            </c-dms-filename>
                        </div>
                    </div>
                </template>
            </v-treeview>
        </div>
    </div>
</template>

<script>


import FTitle         from "@/modules/core/components/utils/FTitle.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Dms            from "@/modules/dms/common/service/Dms";
import Inb            from "@/modules/inb/service/Inb";
import Inc            from "@/modules/inc/service/Inc";
//import Core           from "@/modules/core/service/Core";
import CDmsFilename   from "@/modules/dms/treeview/components/private/PDmsTreeviewFile.vue";

export default {
    name: "DmsOverview",

    components: {
        CDmsFilename,
        CToolbarButton,
        FTitle
    },

    props: {
        incident: {
            required: true,
            type    : Object
        }
    },

    data: () => ({
        expand : false,
        dmsIncident: null,
        search: null,
        documents: null
    }),

    computed: {
        folders () {
            if (!this.dmsIncident || !this.dmsIncident.folder) {
                return [];
            }

            return this.dmsIncident.folder.entries.slice ().sort ((l,r) => l.name.localeCompare(r.name));
        },

        filter () {
            return (item, search, textKey) => {
                return item[textKey].indexOf(search) > -1;
            }
        },

        title () {
            return "Dokumente zum Ereignis";
        }
    },

    created() {
        this.$bus.$on(Inb.event.refresh, this.load);
        this.$bus.$on(Dms.event.document.refresh, this.load);
    },

    beforeDestroy() {
        this.$bus.$off(Inb.event.refresh, this.load);
        this.$bus.$off(Dms.event.document.refresh, this.load);
    },

    methods: {
        onDocument (document) {
            document.unitName = this.getUnit(document);
            this.$bus.$emit(Dms.event.document.selected, {
                document: document,
                callback: this.onAssigned
            });
        },

        /*
        onRefresh () {
            Core.loading(this, true);
            Inc.document.refresh(this.incident.id, () => {
                this.load();
                Core.loading(this, false);
            }, () => {
                Core.loading(this, false);
            });
        },

         */

        onExpand () {
            this.expand = !this.expand;
            this.$refs.treeview.updateAll(this.expand);
        },

        onAssigned () {
            this.load();
        },

        load () {
            Inc.document.byIncident(this.incident.id, (documents => {
                this.documents = documents;
            }));

            Dms.incident(this.incident.id, (dmsIncident) => {
                this.dmsIncident = dmsIncident;
            });
        },

        getUnit (document) {
            if (!document) {
                return null;
            }

            if (document.unitName) {
                return document.unitName;
            }

            const doc = this.documents.find (d => d.id === document.id);
            if (doc) {
                document.unitName = doc.unitName;
                return doc.unitName;
            }

            return null;
        }
    }
}
</script>

<style scoped>

.doc-tree-item {
    width: 25px;
    height: 25px;
    font-size: 13pt!important;
}

::v-deep .v-treeview-node__root {
    min-height: 30px;
    padding-left: 0;
    padding-right: 0;
    margin-left: -6px;
}

::v-deep .v-input__icon--clear {
    margin-right: -3px;
}

::v-deep .v-treeview-node__toggle {
    width: 25px;
    height: 25px;
}

::v-deep .v-treeview-node__content {
    margin-left: 0!important;
}

.unit-doc {
    padding-left: 4px;
    padding-right: 4px;
    border-radius: 2px;
    border-style: solid;
    border-color: #0a68b8;
    border-width: 1px;
    margin-top: -1px;
}

::v-deep .theme--light.v-icon:focus:after {
    opacity: 0;
}

::v-deep .v-treeview--dense .v-treeview-node__root {
    min-height: 30px;
}

::v-deep .v-treeview-node__content {
    margin-left: 0;
}

</style>